<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import OPCRView from "@/components/widgets/opcr-view.vue";
import ItemsView from "@/components/widgets/items-view.vue";
import OPCRModal from "@/components/modals/opcr-modal.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import OpcrLogs from "@/router/views/office/office-widgets/opcr-logs.vue";
import ApiModal from "@/components/modals/api-modal.vue";
import ApiLogs from "@/components/modals/api-logs.vue";
import ProposalModal from "@/components/modals/proposal-modal.vue";
import RawData from "@/components/widgets/raw-data.vue";
import ProposalResourceUpdate from "@/router/views/office/office-widgets/proposal-resource-item.vue";
import FundSourceModal from "@/components/modals/fund-source-list.vue";
import ReportParameters from "@/components/widgets/bp-report-parameters.vue";
import Swal from "sweetalert2";
import { cloneDeep, groupBy } from "lodash";
export default {
  page: {
    title: "Budget Call",
  },
  components: {
    Layout,
    PageHeader,
    OPCRView,
    ItemsView,
    OPCRModal,
    PrintOptions,
    AttachmentModal,
    OpcrLogs,
    RawData,
    ApiModal,
    ProposalModal,
    ProposalResourceUpdate,
    ApiLogs,
    ReportParameters,
    FundSourceModal
  },
  data() {
    return {
      title: `Budget Call`,
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: `Budget Call`,
          active: true,
        },
      ],
      selectAllAPI: true,
      selectedTransfer: {},
      selectedApi: {},
      selectedApiId: 0,
      carts: [],
      startTranferApiToOPCR: false,
      startTransferAPI: false,
      departmentOPCRs: [],
      frontPage: true,
      itemLoading: false,
      resourceItems: [],
      apiName: "",
      selectedItem: 0,
      selectedOPCR: null,
      selectedTarget: null,
      opcrs: [],
      targetData: [],
      itemList: [],
      tableBusy: false,
      loadItems: false,
      loadOpcrs: false,
      loadDepartmentOPCRs: false,
      directionElement: null,
      startSelection: false,
      modalTitle: '',
      templates: [],
      selectedTemplate: null,
      showTemplatePopover: false,
      searchTemplate: '',
      loadTemplates: false,
      selectedAllTarget: null,
      availableAccounts: [],
      budgets: [],
      sections: [],
      bpReportType: 'details'
    }
  },
  computed: {
    filteredTemplates() {
      let data = this.templates;
      if (this.searchTemplate.trim() != "" && this.searchTemplate) {
        data = data.filter((item) => {
          return item.description.toUpperCase().includes(this.searchTemplate.toUpperCase());
        });
      }
      return data;
    },
  },
  methods: {
    async changeCampus(campusId) {
      this.selectedTemplate = null;
      this.templates = [];
      this.resetSelection();
      this.getTemplates(campusId, this.$store.state.data.cycle);
    },
    async changeDU(du) {
      this.frontPage = true;
      this.resetSelection();
      this.pageLoader(true);
      if (this.selectedTemplate) {
        await this.getMyOpcrs(this.selectedTemplate.id, du.id);
        this.getMyTargets(this.selectedTemplate?.lockToCycle ? this.selectedTemplate?.cycle : this.$store.state.data.cycle, du.id);
      } else {
        this.getMyTargets(this.$store.state.data.cycle, du.id);
      }
      this.pageLoader(false);
      this.getDepartmentOPCRs(this.$store.state.data.cycle, du.id);
    },
    async changeCycle(cycle, created = false) {
      this.selectedTemplate = null;
      this.templates = [];
      if (!created) {
        this.frontPage = true;
      }
      this.resetSelection();
      this.pageLoader(true);
      await this.getTemplates(this.$store.state.data.selectedCampus.id, cycle);
      if (this.selectedTemplate) {
        await this.getMyOpcrs(this.selectedTemplate.id, this.$store.state.data.selectedDU.id);
        await this.getMyTargets(this.selectedTemplate?.lockToCycle ? this.selectedTemplate?.cycle : cycle, this.$store.state.data.selectedDU.id);
      } else {
        await this.getMyTargets(cycle, this.$store.state.data.selectedDU.id);
      }
      this.pageLoader(false);
      // this.loadDepartmentOPCRs = true;
      // await this.getDepartmentOPCRs(cycle, this.$store.state.data.selectedDU.id);
      // this.loadDepartmentOPCRs = false
    },
    async getCartItems(id) {
      await this.$store
        .dispatch("deliveryunititemcart/GetDeliveryUnitItemCartByDU", id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.map(item => {
            item.filterKey = `${item.item.itemName} ${item.item.description}`;
          })
          this.carts = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getDepartmentOPCRs(cycle, deliveryUnitId) {
      this.departmentOPCRs = [];
      await this.$store
        .dispatch("departmentpreopcr/GetAllPostedOPCR", { cycle, deliveryUnitId })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.map(item => {
            item.viewApi = false;
            item.apis = [];
            item.apiLoading = false;
          })
          let grpData = [];
          let grpDep = groupBy(res.data, 'departmentId');
          for (const [key, value] of Object.entries(grpDep)) {
            grpData.push({
              id: value[0].department.id,
              department: value[0].department,
              opcrs: value,
              selectionOfAPI: false,
              selectAllAPI: false,
              searchAPI: '',
            })
          }
          this.departmentOPCRs = grpData;
        })
        .catch(() => {
          this.showToast("Getting Department Opcrs Failed", "error");
        });
    },
    resetSelection() {
      this.selectedOPCR = null;
      this.selectedTarget = null;
      this.selectedItem = 0;
      this.selectAllAPI = false;
      this.targetData = [];
      this.opcrs = []
    },
    async getTemplates(campusId, cycle) {
      this.loadTemplates = true;
      try {
        const { data: response } = await this.$store.dispatch("budgetproposaltemplate/GetActiveBudgetProposalTemplate", campusId);
        if (response.error) {
          this.loadTemplates = false;
          return this.showToast(response.errorMessage, "error");
        }
        this.templates = response;
        if (this.templates.length > 0) {
          this.selectedTemplate = this.templates.find(x => x.cycle == cycle) || null;
        }
      } catch (err) {
        return this.showToast("Getting Templates Failed", "error");
      } finally {
        this.loadTemplates = false;
      }
    },
    async getMyOpcrs(proposalId, deliveryUnitId) {
      this.opcrs = [];
      this.loadOpcrs = true;
      this.selectedOPCR = null;
      try {
        const { data: response } = await this.$store.dispatch("preopcr/GetProposalPreOpcr", { proposalId, deliveryUnitId });
        if (response.error) {
          this.loadOpcrs = false;
          return this.showToast(response.errorMessage, "error");
        }
        if (!response) {
          this.loadOpcrs = false;
          this.opcrs = [];
          return;
        }
        this.opcrs = response;
        if (this.opcrs.length > 0) {
          this.selectedOPCR = cloneDeep(this.opcrs[0]);
          this.getAllAPI()
        }
      } catch (err) {
        return this.showToast("Getting Opcrs Failed", "error");
      } finally {
        this.loadOpcrs = false;
      }
    },
    async getMyTargets(cycle, deliveryUnitId) {
      this.selectedItem = 0;
      this.targetData = [];
      this.itemList = [];
      this.loadItems = true;
      this.apiName = "";
      await this.$store
        .dispatch("planningtarget/GetPostedPlanningTargetByDU", { cycle, deliveryUnitId })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.loadItems = false;
          res.data.sort((a, b) => b.id - a.id);
          res.data.forEach((item) => {
            item.searchList = `${item.description} ${item.planningMainTarget.indicatorItem.indicatorItemName}`;
            item.prexC = item.planningMainTarget.indicatorItem.indicator.prexc.prexcName;
            item.indicatorItem = item.planningMainTarget.indicatorItem.indicatorItemName;
            item.classification = item.planningMainTarget.indicatorItem.indicatorItemClassification.classification;
            item.sort = 3;
            if (item.planningMainTarget.indicatorItem.indicatorItemClassification.classification.toLowerCase().includes('strategic')) {
              item.sort = 1;
            } else if (item.planningMainTarget.indicatorItem.indicatorItemClassification.classification.toLowerCase().includes('core')) {
              item.sort = 2
            }
          });
          this.itemList = res.data.sort((a, b) => a.sort - b.sort);
        })
        .catch((err) => {
          this.loadItems = false;
          this.showToast("Getting Target went wrong!", "error");
        });
    },
    selectIndicatorItem(row) {
      if (this.startTransferAPI) {
        return this.transferApiNow(row);
      }
      this.selectedItem = row.id;
      this.apiName = row.description;
      this.selectedTarget = row;
      this.$refs.opcrDefault.showTarget = false;
      this.selectAllAPI = false;
      this.getAPIbyOPCRandTarget();
    },
    async getAPIbyOPCRandTarget() {
      if (!this.selectedTarget) {
        return;
      }
      this.tableBusy = true;
      this.targetData = [];
      await this.$store
        .dispatch("planningapi/GetPlanningApisByTargetAndOPCR", { preplanningTargetId: this.selectedTarget.id, preOPCRId: this.selectedOPCR.id })
        .then((res) => {
          if (res.data.error) {
            this.tableBusy = false;
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.forEach((item) => {
            item.showAttachments = false;
            item.attachmentLoading = false;
            item.addDocu = false;
            item.fileSearch = "";
            item.attachments = [];
            item.totalResources = this.formatCurrency(item.total);
            item.selected = false;
            item.preOPCR = this.opcrs.find(x => x.id == item.preOPCRId)
          });
          this.targetData = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
      this.tableBusy = false;
    },
    transferApiIfs(row) {
      if (this.selectedTransfer.planningApiId == row.id || row.departmentPlanningApiId) {
        return false;
      }
      return true;
    },
    transferItem(arr) {
      this.selectedTransfer = cloneDeep(arr[0]);
      this.frontPage = true;
    },
    cancelTransfer() {
      this.frontPage = true;
      this.selectedTransfer = {};
    },
    selectTransferApi({ row, parent }) {
      let data = {
        id: this.selectedTransfer.id,
        planningApiId: row.id,
      }
      this.$store
        .dispatch("planningapiresource/MovePlanningApiResource", data)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          row.total += this.selectedTransfer.total;
          row.totalResources = this.formatCurrency(row.total);
          if (parent) {
            let index = parent.planningApis.findIndex((e) => e.id === this.selectedTransfer.planningApiId);
            if (index > -1) {
              parent.planningApis[index].total -= this.selectedTransfer.total;
              parent.planningApis[index].totalResources = this.formatCurrency(parent.planningApis[index].total);
            }
          } else {
            let index = this.targetData.findIndex((e) => e.id === this.selectedTransfer.planningApiId);
            if (index > -1) {
              this.targetData[index].total -= this.selectedTransfer.total;
              this.targetData[index].totalResources = this.formatCurrency(this.targetData[index].total);
            }
          }
          this.cancelTransfer();
          this.showToast("Successfully transferred!", "success");
        })
        .catch((err) => {
          this.showToast("Cannot transfer!", "error");
        });
    },
    closeOPCRPopover() {
      this.startTranferApiToOPCR = false;
    },
    closeUpdateModal(data) {
      let index = this.resourceItems.findIndex(x => x.id == data.id);
      this.resourceItems[index].totalQuantity = data.quantity;
      this.resourceItems[index].totalWithInflation = data.amount;
    },
    successUpdateResource(data) {
      let index = this.resourceItems.findIndex(x => x.id == data.id);
      this.resourceItems.splice(index, 1, data);
    },
    successAddResource(data) {
      this.resourceItems.push(data);
    },
    totalResourceItemAmt() {
      var data = this.resourceItems;
      var sum = 0;
      data.forEach((item) => {
        sum += parseFloat(item.totalWithInflation);
      });
      return this.formatCurrency(sum);
    },
    updateItemColumn(data) {
      if (data.type === 'deduct') {
        this.resourceItems.find((e) => e.id == data.id)[data.column] -= data.value;
      } else if (data.type === 'add') {
        this.resourceItems.find((e) => e.id == data.id)[data.column] += data.value;
      } else {
        this.resourceItems.find((e) => e.id == data.id)[data.column] = data.value;
      }
    },
    updateTotals(data) {
      if (this.selectAllAPI) {
        let apiIndex = this.selectedAllTarget.planningApis.findIndex((e) => e.id == data.apiId)
        this.selectedAllTarget.planningApis[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
        this.selectedAllTarget.planningApis[apiIndex].totalCurrency = this.formatCurrency(this.totalResourceItemAmt());
      } else {
        let apiIndex = this.targetData.findIndex((e) => e.id === data.apiId);
        this.targetData[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
        this.targetData[apiIndex].totalCurrency = this.formatCurrency(this.totalResourceItemAmt());
      }
    },
    showCart() {
      this.$bvModal.show('cart-items-modal');
    },
    removeFromCart(id) {
      this.$store
        .dispatch("deliveryunititemcart/DeleteDeliveryUnitItemCart", id)
        .then((res) => {
          if (res.data.error) {
            return;
          }
          let index = this.carts.findIndex(x => x.id == id);
          this.carts.splice(index, 1);
        })
        .catch((err) => {
          return;
        });
    },
    createNewOPCR() {
      this.$refs.opcrModal.resetForm();
      this.$refs.opcrDefault.showOPCR = false;
      this.modalTitle = `Create New Budget Proposal`;
      this.$bvModal.show('opcr-modal');
    },
    onSubmitOPCR(data) {
      if (!this.selectedTemplate) {
        return this.showToast("No template selected!", "error");
      }
      data.deliveryUnitId = this.$store.state.data.selectedDU.id;
      data.cycle = this.selectedTemplate.cycle;
      data.budgetProposalId = this.selectedTemplate.id;
      if (data.id > 0) {
        this.$store.dispatch("preopcr/UpdatePreOpcr", data)
          .then((res) => {
            let index = this.opcrs.findIndex(x => x.id == data.id);
            this.opcrs.splice(index, 1, data);
            if (this.selectedOPCR.id == data.id) {
              this.selectedOPCR = cloneDeep(data);
            }
            this.showToast("Successfully updated!", "success");
            this.$bvModal.hide('opcr-modal');
            this.$refs.opcrDefault.showOPCR = true;
          })
          .catch(() => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        this.$store.dispatch("preopcr/AddPreOpcr", data)
          .then((res) => {
            this.opcrs.push(res.data);
            this.showToast("Successfully created!", "success");
            this.$bvModal.hide('opcr-modal');
            this.$refs.opcrDefault.showOPCR = true;
          })
          .catch(() => {
            this.showToast("Something went wrong!", "error");
          });
      }
    },
    async printWFP() {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/PrePlanning/WFP",
        routeVariables: [this.selectedOPCR.id],
      });
      this.$bvModal.show("print-options-modal");
    },
    async printOPCR(type = 2) {
      let apiUrl = "api/Report/PrePlanning/OPCR/Proposal";
      if (type == 2) {
        apiUrl = "api/Report/PrePlanning/OPCR/Proposal";
      } else if (type == 3) {
        apiUrl = "api/Report/PrePlanning/OPCR/Proposal";
      } else if (type == 4) {
        apiUrl = "api/Report/PrePlanning/OPCR/Proposal";
      }
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: [this.selectedOPCR.id],
      });
      this.$bvModal.show("print-options-modal");
    },
    async printDBM2({ form, status }) {
      this.$refs.printOpt.putOptions({
        apiUrl: `api/Report/Planning/BudgetProposal/DBM/Form2/${form}/${status}`,
        routeVariables: [this.selectedOPCR.id],
      });
      this.$bvModal.show("print-options-modal");
    },
    async printBudgetSummary() {
      this.bpReportType = 'summary';
      this.$refs.reportParameters.resetForm(null, true);
      this.$bvModal.show("bp-report-parameters-modal");
    },
    async printBudgetDetails() {
      this.bpReportType = 'details';
      this.$refs.reportParameters.resetForm();
      this.$bvModal.show("bp-report-parameters-modal");
    },
    submitParams(body) {
      let routeVar = [this.$store.state.data.selectedDU.id, this.selectedTemplate.id];
      let apiUrl = "";
      if (this.bpReportType == 'summary') {
        apiUrl = "api/Report/Planning/BudgetProposal/DeliveryUnit/Summary";
        routeVar.push(body.status)
      } else {
        apiUrl = "api/Report/Planning/BudgetProposal/DeliveryUnit";
      }
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVar,
        body: body,
      });
      this.$bvModal.show("print-options-modal");
    },
    async printDULIB() {
      if (this.$store.state.data.selectedCampus.isExternal) {
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/PrePlanning/LIB/WFP",
          routeVariables: [this.selectedOPCR.id],
        });
      } else {
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/PrePlanning/LIB",
          routeVariables: [this.selectedOPCR.id],
        });
      }
      this.$bvModal.show("print-options-modal");
    },
    printPPMPByApi({ id, type }) {
      this.$refs.printOpt.putOptions({
        apiUrl: type == 2 ? "api/Report/Procurement/Planning/PPMP/Api/Report" : "api/Report/PrePlanning/PPMP/API",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    printIndicativePR(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/PrePlanning/PR",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    async getBudgets() {
      await this.$store
        .dispatch("accountgroups/getAllAccountGroup")
        .then((response) => {
          if (response.error) {
            return this.showToast(response.errorMessage, "error");
          }
          let expenses = response.data.filter(x => x.accountType?.toLowerCase().includes('expense'));
          let grp = groupBy(expenses, 'fundClassificationId');
          let data = [];
          for (const [key, value] of Object.entries(grp)) {
            let filterKey = value[0].fundClassification.classification + ' ' + value.map(x => x.groupName).join(' ')
            data.push({
              fundClassificationId: key,
              fundClassification: value[0].fundClassification,
              accounts: value,
              showData: false,
              filterKey: filterKey,
            })
          }
          this.budgets = expenses;
          this.availableAccounts = data;
        })
        .catch(() => {
          this.showToast("Something went wrong. Cannot fetch available PREXCs", "error");
        });
    },
    async goToPPMP(row) {
      this.selectedApi = row;
      this.selectedApiId = row.id;
      this.apiIndex = this.targetData.indexOf(row);
      this.title = "API Resources";
      this.frontPage = false;
      this.scrollToTop();
      this.itemLoading = true;
      this.resourceItems = [];
      await this.getResourceDetails(row.id);
    },
    async goToPPMPAll({ row, parent }) {
      this.selectedAllTarget = parent;
      this.selectedApi = row;
      this.selectedApiId = row.id;
      this.title = "API Resources";
      this.frontPage = false;
      this.scrollToTop();
      this.itemLoading = true;
      this.resourceItems = [];
      await this.getResourceDetails(row.id);
    },
    updateOPCR(opcr) {
      this.$refs.opcrDefault.showOPCR = false;
      this.modalTitle = `Update ${this.$store.state.data.selectedCampus.isExternal ? 'WFP' : 'OPCR'}`;
      this.$refs.opcrModal.updateForm(opcr);
      this.$bvModal.show('opcr-modal');
    },
    deleteOPCR(opcr) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("preopcr/DeletePreOpcr", opcr.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.opcrs.findIndex(x => x.id == opcr.id);
              this.opcrs.splice(index, 1);
              if (opcr.id == (this.selectedOPCR && this.selectedOPCR.id)) {
                this.selectedOPCR = null;
                this.$refs.opcrDefault.showOPCR = true;
              }
              this.showToast("Successfully deleted!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    openSelectionOfApi() {
      this.startSelection = !this.startSelection;
      this.selectedApiActions = '';
      if (this.startSelection) {
        this.targetData.map(x => {
          x.selected = false;
        })
      }
    },
    transferApiToOPCR() {
      this.startTranferApiToOPCR = true;
      this.$refs.opcrDefault.showOPCR = true;
      this.$nextTick(() => {
        setTimeout(() => {
          let element = document.getElementById('opcrRef').getBoundingClientRect();
          this.directionElement = element;
        }, 100);
      });
    },
    updateItem(props) {
      // this.form = cloneDeep(props.item);
      // this.form.dateCompleted = new Date(props.item.dateCompleted);
      // this.form.climateAddress = props.item.isAdaptation ? 'Adaptation' : 'Mitigation';
      // this.indexSelected = this.targetData.indexOf(props.item);
      // this.form.apiTypeId = props.item.apiTypeId ?? 0;
      // this.apiType = props.item.apiType;
      // this.$v.form.$reset();
      // this.$v.previousWork.$reset();
      this.selectedItem = props.item.planningTargetId;
      this.modalTitle = "Update Api";
      this.$refs.proposalModal.updateForm(props.item);
      this.$bvModal.show("proposal-modal");
    },
    deleteItem(props) {
      var index = this.targetData.indexOf(props.item);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(
              "planningapi/DeletePlanningApi",
              props.item.id
            )
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              if (res.status == 204) {
                this.targetData.splice(index, 1);
                this.showToast(
                  "Successfully deleted!",
                  "success"
                );
              }
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    updateItemAll({ row, parent }) {
      this.selectedAllTarget = parent;
      this.selectedItem = row.planningTargetId;
      this.modalTitle = "Update Proposal";
      this.$refs.proposalModal.updateForm(row);
      this.$bvModal.show("proposal-modal");
    },
    deleteItemAll({ row, parent }) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("planningapi/DeletePlanningApi", row.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = parent.planningApis.findIndex(x => x.id == row.id);
              parent.planningApis.splice(index, 1);
              this.showToast("Successfully deleted!", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    addApi(target) {
      if (!this.selectedOPCR) {
        return this.showToast(`Please select ${this.$store.state.data.selectedCampus.isExternal ? 'a WFP' : 'an OPCR'}!`, "error");
      }
      if (target) {
        this.selectedItem = target.planningTargetId;
        this.selectedTarget = this.itemList.find(x => x.id == target.planningTargetId);
      }
      this.selectedAllTarget = target ? target : this.selectedTarget;
      this.$refs.proposalModal.onReset();
      this.modalTitle = `Create New Activity Program Initiative`;
      this.$bvModal.show("proposal-modal");
    },
    async getAllAPI() {
      this.selectAllAPI = true;
      this.targetData = [];
      this.tableBusy = true;
      this.selectedTarget = null;
      this.$refs.opcrDefault.showTarget = false;
      this.apiName = 'All';
      this.selectedItem = 0;
      if (!this.selectedOPCR) {
        return this.tableBusy = false;
      }
      await this.$store
        .dispatch("planningapi/GetAllProposalApis", {
          opcrId: this.selectedOPCR.id,
          cycle: this.selectedTemplate?.lockToCycle ? this.selectedTemplate?.cycle : this.$store.state.data.cycle
        })
        .then((res) => {
          if (res.data.error) {
            this.tableBusy = false;
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.forEach((x) => {
            x.sort = 3;
            if (x.type.toLowerCase().includes('strategic')) {
              x.sort = 1;
            } else if (x.type.toLowerCase().includes('core')) {
              x.sort = 2
            }
            x.showApis = x.planningApis.length;
            x.filterKey = `${x.planningTarget}`;
            x.planningApis.map(item => {
              item.showAttachments = false;
              item.attachmentLoading = false;
              item.addDocu = false;
              item.fileSearch = "";
              item.attachments = [];
              item.totalResources = this.formatCurrency(item.total);
              item.selected = false;
              x.filterKey += ` ${item.name}`;
              item.filterKey = `${x.planningTarget} ${item.name}`;
            }).sort((a, b) => a.name.localeCompare(b.name))
          });
          this.targetData = res.data.sort((a, b) => a.planningTarget.localeCompare(b.planningTarget)).sort((a, b) => a.sort - b.sort);
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
      this.tableBusy = false;
    },
    selectOPCR(opcr) {
      if (this.startTranferApiToOPCR) {
        if (this.selectedOPCR.id == opcr.id) {
          this.showToast('Cannot transfer to the same OPCR', 'error');
          return;
        }
        this.transferToSelectedOPCR(opcr.id);
      } else {
        this.selectedOPCR = cloneDeep(opcr);
        this.$refs.opcrDefault.showOPCR = false;
        if (this.selectAllAPI) {
          this.getAllAPI();
        } else {
          this.getAPIbyOPCRandTarget();
        }
      }
    },
    transferToSelectedOPCR(id) {
      let data = {
        preOPCRId: id,
        planningApiIds: [],
      }
      this.targetData.map(x => {
        x.planningApis.map(y => {
          if (y.selected) {
            data.planningApiIds.push(y.id);
          }
        })
      })
      Swal.fire({
        title: "Are you sure?",
        text: "You want to transfer this?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, transfer it!",
      }).then(async (result) => {
        if (result.value) {
          this.$store
            .dispatch("preopcr/AddPreOpcrItems", data)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              data.planningApiIds.map(x => {
                let index = this.targetData.findIndex(y => y.id == x);
                this.targetData.splice(index, 1);
              });
              this.startTranferApiToOPCR = false;
              this.openSelectionOfApi();
              this.$refs.opcrDefault.showOPCR = false;
              this.showToast("Successfully transferred!", "success");
            })
            .catch(() => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    viewOPCRLogs() {
      this.$bvModal.show('opcr-logs-modal');
      this.$refs.opcrLogs.modalTitle = `${this.selectedOPCR.title} Logs`
      this.$refs.opcrLogs.getData(this.selectedOPCR);
    },
    closeTargetPopOver() {
      this.startTransferAPI = false;
    },
    postOPCR(opcr) {
      if (new Date(this.selectedTemplate.endDateTime) < new Date()) {
        return this.showToast("Cannot post. Proposal deadline has passed!", "error");
      }
      Swal.fire({
        title: "Are you sure?",
        text: "You want to post this?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, post it!",
      }).then(async (result) => {
        if (result.value) {
          this.$store
            .dispatch("preopcr/PostPreOpcr", opcr.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              opcr.status = 'POSTED';
              this.showToast("Successfully posted!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    async transferApiToKPI() {
      this.startTransferAPI = true;
      this.$refs.opcrDefault.showTarget = true;
      await this.wait(200);
      let element = document.getElementById('targetRef').getBoundingClientRect();
      this.directionElement = element;
    },
    showImportApis() {
      this.departmentOPCRs.map(x => {
        x.opcrs.map(y => {
          y.viewApi = false;
        })
      })
      this.$bvModal.show('import-apis-modal');
    },
    async viewApis(row) {
      row.viewApi = !row.viewApi;
      if (row.viewApi) {
        row.apiLoading = true;
        await this.getDepartmentApis(row);
        row.apiLoading = false;
      }
    },
    async showApiAttachments(api) {
      this.$bvModal.show("upload-attachment-modal");
      this.$refs.attachmentModal.setUploadOpt({
        type: "API Special Projects",
        placement: "left",
        folder: "Office",
      });
      await this.$refs.attachmentModal.getData(api.id);
    },
    async printPPMP(type) {
      if (type == 2) {
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/Procurement/Planning/PPMP/Report",
          routeVariables: [this.selectedOPCR.id],
        });
      } else {
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/PrePlanning/PPMP/OPCR",
          routeVariables: [this.selectedOPCR.id],
        });
      }
      this.$bvModal.show("print-options-modal");
    },
    closeTemplatePopover() {
      this.showTemplatePopover = false;
    },
    async setTemplate(template) {
      this.selectedTemplate = template;
      this.showTemplatePopover = false;
      this.pageLoader(true);
      await this.getMyOpcrs(template.id, this.$store.state.data.selectedDU.id);
      if (template?.lockToCycle) {
        await this.getMyTargets(template.cycle, this.$store.state.data.selectedDU.id);
      } else {
        await this.getMyTargets(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id);
      }
      this.pageLoader(false);
    },
    onSubmitApi(data) {
      data.preOPCRId = this.selectedOPCR.id;
      data.isAdaptation = data.climateAddress === 'Adaptation' ? true : false;
      if (data.id > 0) {
        this.$store
          .dispatch("planningapi/UpdatePlanningApi", data)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            if (this.selectAllAPI) {
              let index = this.selectedAllTarget.planningApis.findIndex(x => x.id == data.id);
              data.filterKey = `${this.selectedAllTarget.planningTarget} ${data.name}`
              this.selectedAllTarget.planningApis.splice(index, 1, data);
            } else {
              this.targetData.splice(this.indexSelected, 1, data);
            }
            this.$bvModal.hide("api-modal");
            this.showToast("Successfully updated!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        data.planningTargetId = this.selectedItem;
        this.$store
          .dispatch("planningapi/CreatePlanningApi", data)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            res.data.total = 0;
            res.data.totalResources = this.formatCurrency(0);
            if (this.selectAllAPI) {
              res.data.filterKey = `${this.selectedAllTarget.planningTarget} ${res.data.name}`
              this.selectedAllTarget.planningApis.push(res.data);
            } else {
              this.targetData.push(res.data);
            }
            this.$bvModal.hide("api-modal");
            this.showToast("Successfully created!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      }
    },
    returnToApi() {
      this.frontPage = true;
    },
    addNewItem() {
      this.$refs['resource-update'].addNewItem();
    },
    async updateResourceItem({ props, type }) {
      this.pageLoader(true);
      this.$refs['resource-update'].getItemInfo(props, type);
      this.pageLoader(false);
    },
    deleteResourceItem(props) {
      var index = this.resourceItems.indexOf(props);
      var apiIndex = -1;
      if (this.selectAllAPI) {
        apiIndex = this.selectedAllTarget.planningApis.findIndex(x => x.id == props.planningApiId);
      } else {
        apiIndex = this.targetData.findIndex(x => x.id == props.planningApiId);
      }
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("planningapiresource/DeletePlanningApiResource", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              if (res.status == 204) {
                this.resourceItems.splice(index, 1);
                if (this.selectAllAPI) {
                  this.selectedAllTarget.planningApis[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
                } else {
                  this.targetData[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
                }
                this.showToast("Successfully deleted!", "success");
              }
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    deleteAllItems() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete all items!",
      }).then(async (result) => {
        if (result.value) {
          let errors = 0;
          for await (const item of this.resourceItems) {
            await this.$store
              .dispatch("planningapiresource/DeletePlanningApiResource", item.id)
              .then((res) => {
                if (res.data.error) {
                  errors++;
                  return;
                }
              })
              .catch((err) => {
                errors++;
                return;
              });
          }
          if (errors > 0) {
            this.showToast("Some items cannot be deleted!", "error");
          } else {
            this.resourceItems = [];
            this.showToast("All items successfully deleted!", "success");
          }
        }
      });
    },
    async getResourceDetails(id) {
      await this.$store
        .dispatch("planningapiresource/GetPlanningApiResourcesByApi", id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.forEach((item) => {
            let budgetInfo = this.budgets.find((x) => x.id == item.accountGroupId);
            item.totalQuantity =
              item.planningApiResourceDetails.reduce(
                (pv, cv) => {
                  return (
                    parseFloat(pv) + parseFloat(cv.quantity)
                  );
                },
                0
              );
            item.financeTemplateBudgetItem = {
              fundSource: budgetInfo.fundSource,
              fundClass: budgetInfo.fundClassification.classification,
              fundClassification: budgetInfo.fundClassification,
              groupName: budgetInfo.groupName,
              accountGroup: budgetInfo.groupName,
              accountId: budgetInfo.id,
              id: budgetInfo.id
            };
            item.showRow = true;
            item.showChild = true;
            item.filterKey = `${item.itemName}`;
          });
          this.resourceItems = res.data;
          this.itemLoading = false;
        })
        .catch((err) => {
          this.itemLoading = false;
          this.showToast("Something went wrong!", "error");
        });
    },
    async getApiSections() {
      try {
        const { data: response } = await this.$store.dispatch("apisection/GetApiSections");
        if (response.error) {
          return this.showToast(response.errorMessage, "error");
        }
        response.forEach(x => {
          x.groups = JSON.parse(JSON.stringify(x.apiSectionGroups));
          x.groupLoading = false;
        });
        this.sections = response;
      } catch (err) {
        this.showToast("Something went wrong!", "error");
      }
    },
    submitProposal(modalData) {
      let data = cloneDeep(modalData);
      data.preOPCRId = this.selectedOPCR.id;
      data.isAdaptation = false;
      data.planningTargetId = this.selectedItem;
      delete data.uploadFiles;
      if (data.id > 0) {
        this.$store
          .dispatch("planningapi/UpdatePlanningApi", data)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            if (this.selectAllAPI) {
              let index = this.selectedAllTarget.planningApis.findIndex(x => x.id == data.id);
              data.filterKey = `${this.selectedAllTarget.planningTarget} ${data.name}`
              this.selectedAllTarget.planningApis.splice(index, 1, data);
            } else {
              this.targetData.splice(this.indexSelected, 1, data);
            }
            this.$bvModal.hide("proposal-modal");
            this.showToast("Successfully updated!", "success");
            if (modalData.uploadFiles.length) {
              this.uploadFiles(modalData.uploadFiles, data.id);
            }
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        this.$store
          .dispatch("planningapi/CreatePlanningApi", data)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            res.data.total = 0;
            res.data.totalResources = this.formatCurrency(0);
            if (this.selectAllAPI) {
              res.data.filterKey = `${this.selectedAllTarget.planningTarget} ${res.data.name}`
              this.selectedAllTarget.planningApis.push(res.data);
            } else {
              this.targetData.push(res.data);
            }
            this.$bvModal.hide("proposal-modal");
            this.showToast("Successfully created!", "success");
            if (modalData.uploadFiles.length) {
              this.uploadFiles(modalData.uploadFiles, res.data.id);
            }
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      }
    },
    async uploadAttachments(data) {
      try {
        let response = await this.$store.dispatch("filemanager/UploadFile", data);
        if (response.data.error) {
          return { error: true, message: response.data.errorMessage };
        }
        return { error: false, data: response.data };
      } catch (e) {
        return { error: true, message: "Something went wrong" };
      }
    },
    async uploadFiles(files, id) {
      let errors = 0;
      for await (const file of files) {
        let data = {
          type: "API Special Projects",
          folder: "Office",
          file: file.file,
          description: file.description,
          removeLoading: true,
          id: id,
        };
        let response = await this.uploadAttachments(data);
        if (response.error) {
          errors++;
        }
      }
      if (errors > 0) {
        this.showToast("Some files cannot be uploaded!", "error");
      }
    },
    showApiLogs(api) {
      this.$bvModal.show('api-log-modal');
      this.modalTitle = `${api.name} Logs`
      this.$refs.apiLogs.getData(api.id, true);
    },
    resubmitApi({ row: api, parent }) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to resubmit this?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, resubmit it!",
      }).then(async (result) => {
        if (!result.value) return;
        await this.$store
          .dispatch("planningapi/PostPlanning", api.id)
          .then((res) => {
            if (res.data.error) {
              this.showToast(res.data.errorMessage, "error");
              return;
            }
            api.status = 'POSTED';
            this.showToast("Successfully resubmitted!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      });
    },
    isLessThan7Days(date) {
      let today = new Date();
      let targetDate = new Date(date);
      let diffTime = targetDate - today;
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 7;
    },
    isDeadlineExpired(date) {
      let today = new Date();
      let targetDate = new Date(date);
      return targetDate < today;
    },
    assignFundSource({ selectedItems, targetApi }) {
      const items = selectedItems || []
      if (!items || items.length === 0) {
        return this.showToast("Please select items to assign fund source.", "warning");
      }
      this.pendingSelectedItems = items;
      this.pendingTargetApi = targetApi;

      if (this.$refs.fundSourceModal) {
        this.$refs.fundSourceModal.getData(this.$store.state.data.selectedCampus.id);
      }
      this.$bvModal.show("fund-source-modal");
    },
    async onFundSourceSelected(fundSource) {
      if (!fundSource || !fundSource.id) {
        return;
      }
      if (!this.pendingSelectedItems || this.pendingSelectedItems.length === 0) {
        return;
      }
      try {
        const data = {
          fundSourceId: fundSource.id,
          fromFinance: false,
          ids: this.pendingSelectedItems.map((item) => ({ id: item.id })),
        };
        const res = await this.$store.dispatch(
          "planningapiresource/SetFSPlanningApiResource",
          data
        );
        const response = res && res.data !== undefined ? res.data : res;
        if (response && response.error) {
          return this.showToast(response.errorMessage || response.message || "Failed to set fund source.", "error");
        }

        this.pendingSelectedItems.forEach((item) => {
          this.$set(item, "fundSource", fundSource.sourceName);
          this.$set(item, "fundSourceId", fundSource.id);
        });

        this.showToast("Fund source assigned successfully.", "success");
      } catch (error) {
        this.showToast("Failed to set fund source.", "error");
      } finally {
        this.pendingSelectedItems = [];
        this.pendingTargetApi = null;
      }
    },
  },
  async mounted() {
    // this.selectAllAPI = false;
    await this.getBudgets();
    await this.changeCycle(this.$store.state.data.cycle, true);
    this.getCartItems(this.$store.state.data.selectedDU.id);
    this.getApiSections();
  },
};
</script>
<template>
  <Layout @changeCycle="changeCycle" @changeDU="changeDU" @changeCampus="changeCampus($event.id)">
    <PageHeader :title="title" :items="items" />
    <ProposalResourceUpdate ref="resource-update" :updatableMixOption="false" :selectedTransfer="selectedTransfer"
      :selectedApiId="selectedApiId" :selectTransferBudget="true" :availableAccounts="availableAccounts" :carts="carts"
      @close-update="closeUpdateModal" @update-item="successUpdateResource" @add-item="successAddResource"
      @specific-item-update="updateItemColumn" @update-totals="updateTotals" @refresh-all="goToPPMP(selectedApi)" />
    <div class="row position-relative">
      <div class="col-12">
        <transition name="slide-fade">
          <div v-if="frontPage">
            <OPCRView ref="opcrDefault" opcrType="planning" :proposal="true" :department="false" :apiName="apiName"
              :selectedItem="selectedItem" :selectedTransfer="selectedTransfer" :selectedOPCR="selectedOPCR"
              :selectAllAPI="selectAllAPI" :selectedTarget="selectedTarget" :opcrs="opcrs" :targetData="targetData"
              :itemList="itemList" :tableBusy="tableBusy" :startSelection="startSelection" :loadItems="loadItems"
              :selectedTemplate="selectedTemplate" @createNewOPCR="createNewOPCR" @getAllAPI="getAllAPI"
              @closeOPCRPopover="closeOPCRPopover" @selectOPCR="selectOPCR" @viewOPCRLogs="viewOPCRLogs"
              @closeTargetPopOver="closeTargetPopOver" @selectIndicatorItem="selectIndicatorItem"
              @openSelectionOfApi="openSelectionOfApi" @selectTransferApi="selectTransferApi" @goToPPMP="goToPPMP"
              @goToPPMPAll="goToPPMPAll" @postOPCR="postOPCR" @addApi="addApi" @deleteItem="deleteItem"
              @deleteItemAll="deleteItemAll" @updateItemAll="updateItemAll" @updateItem="updateItem"
              @deleteOPCR="deleteOPCR" @updateOPCR="updateOPCR" @transferApiToOPCR="transferApiToOPCR"
              @transferApiToKPI="transferApiToKPI" @showImportApis="showImportApis"
              @showApiAttachments="showApiAttachments" @printDULIB="printDULIB" @printPPMP="printPPMP"
              @printPPMPByApi="printPPMPByApi" @printWFP="printWFP" @printOPCR="printOPCR"
              @printIndicativePR="printIndicativePR" @printDBM2="printDBM2" @show-logs="showApiLogs"
              @resubmitApi="resubmitApi" @printBudgetSummary="printBudgetSummary"
              @printBudgetDetails="printBudgetDetails">
              <template #proposal-opts>
                <div class="mb-3 border-dashed-img position-relative py-4 px-3 text-center cursor-pointer"
                  id="selectTemplate" :class="{ 'info selected': selectedTemplate }">
                  <RawData :data="selectedTemplate" v-if="$store.state.decrypt.isAdmin() && selectedTemplate" />
                  <template v-if="selectedTemplate">
                    <p class="mb-0 text-info font-size-16">{{ `${selectedTemplate.description}` }}</p>
                  </template>
                  <template v-else>
                    No Template for this cycle. Click to Select another Template
                  </template>
                </div>
                <b-popover :show.sync="showTemplatePopover" :target="`selectTemplate`"
                  :custom-class="`popoverOPCRClass`" triggers="click" placement="right" id="opcrRef">
                  <template v-slot:title>
                    <div class="d-flex justify-content-between align-items-center">
                      <p class="m-0">Select Template</p>
                      <button type="button" class="btn btn-sm btn-danger" @click="closeTemplatePopover">
                        <i class="bx bx-x"></i>
                      </button>
                    </div>
                  </template>
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div>
                      <input type="text" class="form-control form-control-sm" v-model="searchTemplate"
                        :placeholder="`Search Template`" v-if="templates.length > 0">
                    </div>
                  </div>
                  <div v-if="loadTemplates">
                    <div class="text-center">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </div>
                  <template v-if="!loadTemplates && templates.length == 0">
                    <div class="text-center">No data found...</div>
                  </template>
                  <template v-if="!loadTemplates && templates.length > 0 && filteredTemplates.length == 0">
                    <div class="text-center">
                      Search not found...
                    </div>
                  </template>
                  <div class="scrollable-div pe-1">
                    <div v-for="opcr in filteredTemplates" :key="opcr.id">
                      <div class="border border-2 p-2 mb-2 position-relative cursor-pointer" @click="setTemplate(opcr)">
                        <RawData :data="opcr" v-if="$store.state.decrypt.isAdmin()" />
                        <p class="mb-0">
                          {{ opcr.description }}
                        </p>
                        <small>{{ opcr.cycle }}</small>
                      </div>
                    </div>
                  </div>
                </b-popover>
              </template>
              <template #proposal-deadline>
                <template v-if="selectedTemplate">
                  <b-alert :variant="isLessThan7Days(selectedTemplate.endDateTime) ? 'warning' : 'info'" class="mb-3"
                    :show="!!selectedTemplate" v-if="!isDeadlineExpired(selectedTemplate.endDateTime)">
                    <i class="bx bx-info-circle me-1"></i>
                    <span>Deadline for proposals will be on <span class="font-weight-bold">{{
                      formatDateWithTime(new Date(selectedTemplate.endDateTime)) }}</span>. Please submit your
                      proposals
                      accordingly.</span>
                  </b-alert>
                  <b-alert :variant="'danger'" class="mb-3" :show="!!selectedTemplate" v-else>
                    <i class="bx bx-info-circle me-1"></i>
                    <span class="font-weight-bold">The deadline for the submission of proposals has passed. You can no
                      longer
                      submit new proposals for this cycle. But you can resubmit the returned proposals.</span>
                  </b-alert>
                </template>
              </template>
            </OPCRView>
          </div>
          <div v-else>
            <ItemsView :loading="itemLoading" :planning="true" :department="false" :proposal="true"
              :selectedApi="selectedApi" :selectedOPCR="selectedOPCR" :tableData="resourceItems"
              @returnToApi="returnToApi" @addItem="addNewItem" @updateItem="updateResourceItem"
              @transferItem="transferItem" @deleteItem="deleteResourceItem" @generateIndicativePR="printIndicativePR"
              @deleteAllItems="deleteAllItems" @assign-fund-source="assignFundSource" />
          </div>
        </transition>
      </div>
    </div>
    <div v-if="startTransferAPI || startTranferApiToOPCR" class="position-fixed"
      style="inset:0;background-color:rgba(0, 0, 0, 0.8);z-index:100;">
      <div v-if="directionElement" class="position-fixed font-size-18"
        :style="{ 'top': `${directionElement.top + (directionElement.height / 2)}px`, 'left': `${directionElement.right + 10}px` }">
        <i class="fas fa-hand-point-left pointing-animation me-3"></i>{{ startTranferApiToOPCR ?
          'Select OPCR from the list'
          : 'Select KPI from the list' }}
      </div>
    </div>
    <div v-if="selectedTransfer.id">
      <div class="position-fixed p-4" style="top: 125px;left:50%;transform:translateX(-50%);">
        <div>
          <span class="bg-success badge p-2 font-size-14">Transfer Item:
            <u>{{ selectedTransfer.itemName }}</u>
          </span>
          <div class="text-center">
            <small>Select API & Budget Item to Proceed</small>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-warning position-fixed" style="bottom: 2%; right: 3%"
        @click="cancelTransfer">
        <i class="bx bx-x me-1"></i>Cancel Transfer Items
      </button>
    </div>
    <OPCRModal ref="opcrModal" :modalTitle="modalTitle" @submit="onSubmitOPCR" />
    <print-options ref="printOpt"></print-options>
    <opcr-logs ref="opcrLogs"></opcr-logs>
    <attachment-modal :wActions="true" title="API Attachments" ref="attachmentModal"></attachment-modal>
    <ApiModal ref="apiModal" @submit="onSubmitApi" :modalTitle="modalTitle"
      :targetName="selectedAllTarget ? selectedAllTarget.planningTarget : ''" />
    <ProposalModal ref="proposalModal" @submit="submitProposal" :modalTitle="modalTitle" :sections="sections"
      :target="selectedAllTarget" />
    <ApiLogs ref="apiLogs" :modalTitle="modalTitle" />
    <ReportParameters ref="reportParameters" @submit="submitParams" />
    <FundSourceModal ref="fundSourceModal" @dropData="onFundSourceSelected" />
  </Layout>
</template>